import { GAME_SFX_CLICK_SELECT } from 'app/constants/GameSFX';

class ButtonSound extends Phaser.Button {
  constructor({ game, id, sfxID, position, skins, ariaLabelID }) {
    super(game, 0, 0, 'buttons');
    this.id = id;
    this.skins = skins;
    this.input.useHandCursor = true;
    this.game.time.events.add(10, this.init, this);
    this.game.controller.uiModel.onAudioIsChanged.add(this.updateDisplayStatus, this);
    this.grouped = position.grouped;
    if (!this.grouped) {
      this.xpos = position.x;
      this.ypos = position.y;
      this.anchor.set(0.5);
      this.updatePosition();
    }
    this.updateDisplayStatus({ isMuted: this.game.controller.uiModel.getIsMuted(), updateController: false });
    this.enable();
  }

  init() {
    // this.enable();
  }

  enable() {
    this.onInputDown.add(this.onDown, this);
    this.onInputOver.add(this.onOver, this);
    this.onInputOut.add(this.onOut, this);
  }

  disable() {
    this.onInputDown.forget();
    this.onInputDown.dispose();
    this.onInputDown.removeAll();
    this.onInputOver.forget();
    this.onInputOver.dispose();
    this.onInputOver.removeAll();
    this.onInputOut.forget();
    this.onInputOut.dispose();
    this.onInputOut.removeAll();
  }

  onOver() {
    this.scale.set(1.2);
  }
  onOut() {
    this.scale.set(1);
  }

  onDown() {
    this.game.sounds.playSFX(GAME_SFX_CLICK_SELECT);
  }
  updatePosition() {
    this.position.set(this.game.width * this.xpos, this.game.height * this.ypos);
  }

  updateDisplayStatus({ isMuted, updateController = true }) {
    console.log('isMuted: ' + isMuted);
    const skin = isMuted ? this.skins.muted : this.skins.unmuted;
    this.setFrames(skin, skin, skin, skin);
    this.game.sound.mute = isMuted;
    if (updateController) {
      this.game.sounds.allowMusic = this.game.sounds.allowEffects = !isMuted;
    }
  }

  destroy(destroyChildren = true) {
    this.disable();
    this.game.controller.uiModel.onAudioIsChanged.remove(this.updateDisplayStatus, this);
    super.destroy(destroyChildren);
  }
}
export default ButtonSound;
